<div [class]="'modal modal-md'">
    <div class="modal-header">
        <span class="modal-title"></span>
        <button class="modal-close" (click)="close()">
            <i class="material-icons">clear</i>
        </button>
    </div>

    <div class="modal-content">
        <div class="file-preview" [style.opacity]="file() ? '1' : '0'">
            <i class="material-symbols-outlined file-icon">
                {{ fileIcon }}
            </i>

            <span class="file-name">
                {{ fileName }}
            </span>
        </div>

        <div class="spinner-wrapper" [style.opacity]="file() ? '0' : '1'">
            <ogs-spinner [color]="'gray'" [size]="'40px'"></ogs-spinner>
        </div>
    </div>

    <div class="modal-btn-row">
        <button class="btn color-secondary" [disabled]="!file()" (click)="download()">
            <i class="material-symbols-outlined">download</i>
            <span>{{ 'comp.file-share-popup.download' | translate }}</span>
        </button>
        <!--    Removed share button until there's a fix for:
                https://feedbackportal.microsoft.com/feedback/idea/c3809d7b-99e4-f011-92b9-7c1e5244b89c
                @if (canShare) {
                <button class="btn color-secondary" [disabled]="!file()" (click)="share()">
                    <i class="material-symbols-outlined">share</i>
                    <span>{{ 'comp.file-share-popup.share' | translate }}</span>
                </button>
            }-->
    </div>
</div>
